import React from "react";
import { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { Switch } from "@progress/kendo-react-inputs";
import "./Switch.scss";

/**
 * Switch component
 * @module
 * @param {string} name - Specifies the name property of the input DOM element
 * @param {func} onChange - Function invoked on value change
 * @param {bool} [value] - Current value
 * @param {bool} [disabled] - Is switch readonly?
 * @param {string} [onLabel] - On label (true)
 * @param {string} [offLabel] - Off label (false)
 * @param {number} [tabIndex] - Switch tab index
 */
const SwitchComponent = (props) => {
  const switchRef = useRef(null);

  useEffect(() => {
    if (switchRef.current && switchRef.current.element && props.name) {
      switchRef.current.element.setAttribute('data-testid', props.name);
    }
  }, [props.name])

  return (
    <Switch
      className={`switch ${props.disabled ? "disabled-field" : ""} `}
      name={props.name}
      onChange={(e) => props.onChange(props.name, e.target.value)}
      checked={props.value || false}
      disabled={props.disabled}
      onLabel={props.onLabel || "a"}
      offLabel={props.offLabel || "n"}
      tabIndex={props.tabIndex}
      ref={switchRef}
    />
  );
};

SwitchComponent.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.bool,
  disabled: PropTypes.bool,
  onLabel: PropTypes.string,
  offLabel: PropTypes.string,
  tabIndex: PropTypes.number,
};

export default SwitchComponent;
